import React, { useState } from "react";
import {  TextField, Box } from "@mui/material";
import {
  CustomButton as CustomMuiButton,
  SaveButton,
} from "../../common/Buttons";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";

const BulkSelectionButton = ({ onSave, disabled }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState("");
  const handleEdit = () => {
    setIsEditing(true);
  };
  const handleSave = () => {
    if (onSave) {
      onSave(value);
    }
    setValue("");
    setIsEditing(false);
  };
  const handleChange = (e) => {
    setValue(e.target.value);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSave();
    }
  };
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {isEditing ? (
        <>
          <TextField
            size="small"
            value={value}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            autoFocus
            placeholder="완료수량을 입력하세요"
            sx={{ mr: 2 }}
          />
          <SaveButton onClick={handleSave} sx={{ width: "40%" }} />
        </>
      ) : (
        <CustomMuiButton
          disabled={disabled}
          variant="contained"
          color="primary"
          onClick={handleEdit}
          startIcon={<DriveFileRenameOutlineIcon />}
        >
          수량 일괄 입력
        </CustomMuiButton>
      )}
    </Box>
  );
};

export default BulkSelectionButton;
